import * as React from "react";
import { useEffect } from "react";
import { useField } from "formik";
import { TimezoneSelect } from "components/common";
import { ControlLabel } from "components/bootstrap";
import useUserDateTime from "hooks/useUserDateTime";
import { Col } from "security-app/components/common/FormBaseStyles";
import { ErrorMessage } from "./ErrorMessage";
function FormikUserTiemezoneSelect({ field, label = null, clearable = false, disabled = false }) {
  const { userTimezone } = useUserDateTime();
  const [{ name, value, onBlur }, { touched, error }, { setValue, setTouched }] = useField({ name: field.name });
  useEffect(() => {
    if (!value && !clearable) setValue(userTimezone);
  }, [clearable, setValue, userTimezone, value]);
  const onChange = (newValue) => {
    setValue(newValue);
    setTouched(true);
  };
  return /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0.3rem", $align: "stretch" }, label && /* @__PURE__ */ React.createElement(ControlLabel, null, label), /* @__PURE__ */ React.createElement(
    TimezoneSelect,
    {
      id: name,
      name,
      value: value || userTimezone,
      clearable,
      onChange,
      onBlur,
      disabled
    }
  ), touched && error && /* @__PURE__ */ React.createElement(ErrorMessage, null, error));
}
export default FormikUserTiemezoneSelect;
